import { createSlice } from '@reduxjs/toolkit';

const unreadDeviceStatusSlice = createSlice({
    name: 'unreadDeviceStatus',
    initialState: {
        unreadDeviceStatusCount: {},
    },
    reducers: {
        setUnreadDeviceStatusCount(state, action) {
            state.unreadDeviceStatusCount = action.payload;
        },
        clearUnreadDeviceStatusCount(state) {
            state.unreadDeviceStatusCount = {};
        },
    },
});

export const { setUnreadDeviceStatusCount, clearUnreadDeviceStatusCount } = unreadDeviceStatusSlice.actions;

export default unreadDeviceStatusSlice.reducer;
